import { RecurringUserTaskStatus } from '@commenda/prisma';
import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';

interface UpdateRecurringTaskProps {
  status?: RecurringUserTaskStatus;
  files?: FileBasic[];
  npsTask?: {
    agentRating: number;
    overallRating: number;
    recommendationRating: number;
    description?: string;
  };
}

export async function updateRecurringTask(
  taskId: string,
  token: string | undefined,
  data: UpdateRecurringTaskProps
): Promise<boolean> {
  const res = await fetcher(
    `recurringUserTasks/${taskId}`,
    { method: 'POST', body: data },
    token
  );

  return res.ok;
}
